import CookieHandler from '../../../i18n/locale_handler/cookie_handler'

const equalSize = (leftOperand, rightOperand, fieldOptions) => {
	let optionsLength = fieldOptions.length;

	return String(rightOperand) === String(optionsLength);
}

const contains = (leftOperand, rightOperand) => {
	if(typeof leftOperand === 'string')
		return leftOperand.includes(rightOperand);
	else if(typeof leftOperand === 'number'){
		return String(leftOperand.toFixed(2)).includes(rightOperand);
	}
	else if(typeof leftOperand === 'object')
		return leftOperand[0].includes(rightOperand);

}

const containsError = (leftOperand, rightOperand, fieldOptions, field) => {
	return field.containsError && field.containsError() || field.errors && field.errors() && field.errors().length > 0;
}

const notContainsError = (leftOperand, rightOperand, fieldOptions, field) => {
	return field.containsError && !field.containsError() || field.errors && field.errors() && field.errors().length === 0 || field.errors && field.errors() === undefined;
}

const parseNumber = (number) => {
	const parsedNumber = parseFloat(number);
	return isNaN(parsedNumber) ? 0 : parsedNumber;
};

const formatteDate = (value) => {
	let arr;
	if(value.match('/')) {
		arr = value.split("/");

		if(CookieHandler.getLanguage() === 'en_US') {
			return `${arr[0]}-${arr[1]}-${arr[2]}`;
		}

		return `${arr[1]}-${arr[0]}-${arr[2]}`;
	}else if(value.length > 9) {
		value = value.substr(0, 10);
		arr = value.split("-");
		return `${arr[1]}-${arr[2]}-${arr[0]}`
	}
	return value
}

const equalOperation = (date, date2) => {		
	return (date && date2) ? date.getTime() === date2.getTime() : date === date2; 		
}

const greaterThan = (date, date2) => {
	return (date && date2) ? date.getTime() > date2.getTime() : false; 
}

const greaterThanOrEqual = (date, date2) => {
	return (date && date2) ? date.getTime() >= date2.getTime() : false; 
}

const lesserThan = (date, date2) => {
	return (date && date2) ? date.getTime() < date2.getTime() : false;
}

const lesserThanOrEqual = (date, date2) => {
	return (date && date2) ? date.getTime() <= date2.getTime() : false;
}

const notEqual = (date, date2) => {
	return (date && date2) ? date.getTime() !== date2.getTime() : date !== date2;
}

const checkedDate = (leftOperand, rightOperand, operator) => {	
	const date = leftOperand ? new Date(formatteDate(leftOperand)) : leftOperand; 
	const date2 = rightOperand ? new Date(formatteDate(rightOperand)) : rightOperand; 				

	return operator(date, date2); 	
}

export const OperatorFunctionsDate = {
	NOT: (operand) => !operand,
	EQUAL: (leftOperand, rightOperand) => checkedDate(leftOperand, rightOperand, equalOperation),
	NOT_EQUAL: (leftOperand, rightOperand) => checkedDate(leftOperand, rightOperand, notEqual),
	IS_EMPTY: (operand) => operand === undefined || operand === null || operand.match(/^\s*$/),
	GREATER_THAN: (leftOperand, rightOperand) => checkedDate(leftOperand, rightOperand, greaterThan),
	LESSER_THAN: (leftOperand, rightOperand) => checkedDate(leftOperand, rightOperand, lesserThan),
	GREATER_THAN_OR_EQUAL: (leftOperand, rightOperand) => checkedDate(leftOperand, rightOperand, greaterThanOrEqual),
	LESSER_THAN_OR_EQUAL: (leftOperand, rightOperand) => checkedDate(leftOperand, rightOperand, lesserThanOrEqual),
	OR: (leftOperand, rightOperand) => leftOperand || rightOperand,
	AND: (leftOperand, rightOperand) => leftOperand && rightOperand,
	ADD: (leftOperand, rightOperand) => parseNumber(leftOperand) + parseNumber(rightOperand),
	SUB: (leftOperand, rightOperand) => parseNumber(leftOperand) - parseNumber(rightOperand),
	MUL: (leftOperand, rightOperand) => parseNumber(leftOperand) * parseNumber(rightOperand),
	DIV: (leftOperand, rightOperand) => parseNumber(leftOperand) / parseNumber(rightOperand),
	MOD: (leftOperand, rightOperand) => parseNumber(leftOperand) % parseNumber(rightOperand),
	CONCAT: (leftOperand, rightOperand) => String(leftOperand) + String(rightOperand),
	MATCH: (leftOperand, rightOperand) => String(leftOperand).match(new RegExp(rightOperand)),
	INCLUDES: (leftOperand, rightOperand) => Array.isArray(leftOperand) && leftOperand.includes(rightOperand),
	NOT_INCLUDES: (leftOperand, rightOperand) => !OperatorFunctions.INCLUDES(leftOperand, rightOperand),
	CONTAINS: contains,
	CONTAINS_ERROR: containsError,
	NOT_CONTAINS_ERROR: notContainsError,
	SIZE_EQUAL: equalSize,
	SIZE_NOT_EQUAL: (leftOperand, rightOperand, fieldOptions) => String(rightOperand) !== String(fieldOptions.length),
	SIZE_GREATER_THAN: (leftOperand, rightOperand, fieldOptions) => parseNumber(fieldOptions.length) > parseNumber(rightOperand),
	SIZE_GREATER_THAN_OR_EQUAL: (leftOperand, rightOperand, fieldOptions) => parseNumber(fieldOptions.length) >= parseNumber(rightOperand),
	SIZE_LESSER_THAN: (leftOperand, rightOperand, fieldOptions) => parseNumber(fieldOptions.length) < parseNumber(rightOperand),
	SIZE_LESSER_THAN_OR_EQUAL: (leftOperand, rightOperand, fieldOptions) => parseNumber(fieldOptions.length) <= parseNumber(rightOperand)
};

export default OperatorFunctionsDate;
